import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { upload } from "../../store/actions/vendor/Vendor";
import { Table, Button } from "reactstrap";
import { connect } from "react-redux";
import {
  addDriver,
  getDriverDetail,
  updateDriver
} from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";

const styles = {
  typo: {
    paddingLeft: "25%",
    marginBottom: "40px",
    position: "relative",
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: "10px",
    color: "#c0c1c2",
    display: "block",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "13px",
    left: "0",
    marginLeft: "20px",
    position: "absolute",
    width: "260px",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);



const AddDriver = (props) => {
  const classes = useStyles();
  const [driver, updateDriver] = useState({
    name: '',
    phone_number: '',
    username: '',
    password: '',
    latitude: null,
    longitude: null
  });
  useEffect(() => {
    var driverId = props.match.params.id;
    if (driverId)
      props.getDriverDetail(driverId).then((obj) => {
        const data = obj.data
        updateDriver({
          id: data.id,
          name: data.name,
          phone_number: data.phone_number,
          username: data.username,
          password: data.password,
          latitude: data.latitude,
          longitude: data.longitude
        })
      });
  }, []);






  const onChange = (event) => {
    let tempDiscount = { ...driver };
    tempDiscount[event.target.name] = event.target.value;
    updateDriver(tempDiscount);
  };


  const onSubmit = (event) => {
    event.preventDefault();
    if (props.match.params.id) {
      props.updateDriver(driver).then((data) => {
        if (data) {
          props.history.push(
            `/admin/delivery-boys`
          );
        }
      }).catch((e) => {

      });
    } else {
      props.addDriver(driver).then((data) => {
        if (data) {
          props.history.push(
            `/admin/delivery-boys`
          );
        }
      }).catch((e) => {

      });
    }
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add/Update Driver</h4>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Driver Name"
              value={driver?.name}
              onChange={onChange}
              name="name"
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Driver Username"
              value={driver?.username}
              onChange={onChange}
              name="username"
              id="username"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Password"
              value={driver?.password}
              onChange={onChange}
              name="password"
              id="password"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Phone Number"
              value={driver?.phone_number}
              type="number"
              onChange={onChange}
              name="phone_number"
              id="phone_number"
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <br />
        </GridContainer>
        <GridContainer>
          {driver?.latitude && driver?.longitude &&
            <GridItem xs={12} sm={12} md={12}>
              <div className="map col-12 col-lg-6" style={{ height: '20em' }}>
                <iframe
                  title="contact"
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBNC9xN76yYhSl9KyDN0mNoKLa63Fkog1M&q=${driver.latitude},${driver.longitude}&center=${driver.latitude},${driver.longitude}&zoom=18`}
                  style={{ border: 0 }}
                  allowFullScreen
                />
              </div>
            </GridItem>
          }
        </GridContainer>
      </CardBody >
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: "#fff",
            backgroundColor: "#9c27b0",
            boxShadow:
              "0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)",
          }}
        >
          {props.match.params.id ? 'Update Driver' : 'Add Driver'}
        </Button>
      </CardFooter>
      <br /> <br />
    </>
  );
};

const mapStateWithProps = (state) => ({
  driver: state.admin.driver,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getDriverDetail: (driverId) => dispatch(getDriverDetail(driverId)),
    updateDriver: (driver) => dispatch(updateDriver(driver)),
    addDriver: (driver) => dispatch(addDriver(driver)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AddDriver);
